module.exports = __webpack_public_path__ + "static/media/tanvi.b8920cc8.JPG";